<template>
<div class="chapter">
<div class="inner_page">
<h1 class="btnew"><a id="page_iii"></a>Sniper on the</h1>
<h1 class="btnew1">Ypres Salient</h1>
<p class="sub">An Infantryman’s War In<br/> The Royal Welsh Fusiliers</p>
<p class="sub1">Based on the War Diaries of William McCrae</p>
<p class="bkaut">Sue Boase</p>
<div class="img_container">
<img alt="images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?44b32962